import React from 'react';
import { clientRegister } from '../data/clients';
export function ClientMarquee() {
  const names = clientRegister.map(c => c.name);
  const loop = [...names, ...names];
  return <section className="border-y border-line bg-parchment py-10" aria-label="Selected clients" data-id="element-40" data-mp="23we3o8a7a56h">
      <p className="text-center font-mono text-[10px] uppercase tracking-[0.14em] text-ink-50" data-id="element-41" data-mp="28uxqeawmbkzw">
        Trusted by tea factories, law firms &amp; institutions across Kenya
      </p>

      <div className="relative mt-7 overflow-hidden" data-id="element-42" data-mp="1b5mc5o42y4ph">
        <div className="ticker-track flex w-max animate-ticker items-center" data-id="element-43" data-mp="1g7bnz5z4mmem">
          {loop.map((name, i) => <span key={`${name}-${i}`} className="flex items-center whitespace-nowrap font-mono text-[12px] text-ink-70" data-id="element-44" data-mp="1l425lxqkxq25" data-mpi={i}>
              <span className="px-7" data-id="element-45" data-mp="shr4mlz29n4t">{name}</span>
              <span className="h-4 w-px bg-line" aria-hidden="true" data-id="element-46" data-mp="sev6oxn7qygd" />
            </span>)}
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-parchment to-transparent" aria-hidden="true" data-id="element-47" data-mp="xdpn5sxpkaxb" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-parchment to-transparent" aria-hidden="true" data-id="element-48" data-mp="3cfjrt9a96f3h" />
      </div>
    </section>;
}